import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_hot-rod-coatings/artifacts/5wdtui8p_MARTENS%20MOTOR%20CO%20with%20thunder_no%20specialty%20coatings.png";

const navLinks = [
  { name: "Home", path: "/" },
  { name: "Services", path: "/services" },
  { name: "Gallery", path: "/gallery" },
  { name: "About", path: "/about" },
  { name: "Contact", path: "/contact" },
];

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => {
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };

  return (
    <nav 
      className="fixed top-0 left-0 right-0 z-50 bg-zinc-950/90 navbar-blur border-b border-white/10"
      data-testid="navbar"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-32">
          {/* Logo */}
          <Link 
            to="/" 
            className="flex-shrink-0"
            data-testid="navbar-logo"
          >
            <img 
              src={LOGO_URL} 
              alt="Martens Motor Co." 
              className="h-28 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                className={`font-body text-sm tracking-wide transition-colors duration-200 ${
                  isActive(link.path)
                    ? "text-amber-500"
                    : "text-zinc-300 hover:text-white"
                }`}
                data-testid={`nav-link-${link.name.toLowerCase()}`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden md:block">
            <Link to="/quote">
              <Button 
                className="bg-amber-500 text-black font-heading text-lg tracking-wide px-6 py-2 rounded-none hover:bg-amber-400 transition-all duration-200 hover:-translate-y-0.5"
                data-testid="get-quote-btn"
              >
                LET'S GET STARTED
              </Button>
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-white p-2"
              data-testid="mobile-menu-btn"
            >
              {isOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isOpen && (
        <div 
          className="md:hidden bg-zinc-950 border-t border-white/10"
          data-testid="mobile-menu"
        >
          <div className="px-4 py-4 space-y-3">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                onClick={() => setIsOpen(false)}
                className={`block font-body text-base py-2 ${
                  isActive(link.path)
                    ? "text-amber-500"
                    : "text-zinc-300"
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link to="/quote" onClick={() => setIsOpen(false)}>
              <Button 
                className="w-full bg-amber-500 text-black font-heading text-lg tracking-wide py-3 rounded-none hover:bg-amber-400 mt-4"
              >
                LET'S GET STARTED
              </Button>
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}
